import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DriverQualificationService } from '../../service/driver-qualification.service';
import { Location } from '@angular/common';
import { AccidentDetailsComponent } from '../incident-detials/accident-details/accident-details.component';
import { AuthorityContactedComponent } from '../incident-detials/authority-contacted/authority-contacted.component';
import { PropertyDamageDetailComponent } from '../incident-detials/property-damage-detail/property-damage-detail.component';
import { InjuredDetailsComponent } from '../incident-detials/injured-details/injured-details.component';
import { WitnessDetailsComponent } from '../incident-detials/witness-details/witness-details.component';

@Component({
    selector: 'app-report-incident',
    templateUrl: './report-incident.component.html',
    styleUrls: ['./report-incident.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatStepperModule,
        MatButtonModule,
        MatIconModule,
        AccidentDetailsComponent,
        AuthorityContactedComponent,
        PropertyDamageDetailComponent,
        InjuredDetailsComponent,
        WitnessDetailsComponent
    ]
})
export class ReportIncidentComponent implements OnInit {
  carrierCompanyName: any;
  loading = false;
  currentStep = 1;
  totalSteps = 6;

  constructor(
     private driverQualificationService: DriverQualificationService,
     private location: Location,
  ) { }

  ngOnInit(): void {
    this.carrierCompanyName = this.driverQualificationService.dqfData?.carrierCompanyName;
  }

  backAction(): void {
    this.location.back();
  }


  onNextStep() {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
    }
  }

  onSubmit() {
    // Handle form submission logic here
    console.log('Form submitted');
    // You can add your submission logic here
  }


}
